import {
  Mail,
  MonitorSmartphone,
  Search,
  Sparkles,
  ClipboardList,
  LayoutDashboard,
  CreditCard,
} from "lucide-react";

export const locationTypes = [
  "Unitate de cazare",
  "Clinică / cabinet",
  "Salon / beauty",
  "Restaurant / evenimente",
  "Studio / servicii",
  "Business local",
  "Alt tip de business",
];

export const packages = [
  {
    icon: MonitorSmartphone,
    title: "Start rapid",
    badge: "Varianta Basic",
    text: "Ideală dacă vrei o prezență online clară și să primești rezervările sau programările direct pe email, fără pași complicați.",
    features: [
      "pagină de prezentare optimizată pentru mobil",
      "formular de rezervare / programare",
      "notificări pe email către business",
      "configurare completă și structură clară",
      "bază bună pentru SEO basic și promovare",
    ],
    cta: "Solicită varianta Basic",
  },
  {
    icon: LayoutDashboard,
    title: "Mai mult control",
    badge: "Varianta Pro",
    text: "Potrivită pentru businessurile care vor să gestioneze cererile într-un mod organizat, dintr-un panou de administrare dedicat.",
    features: [
      "tot ce include varianta Basic",
      "sistem de fidelizare (vouchere promoționale)",
      "panou de administrare pentru rezervări / programări",
      "gestionare status cereri și vizibilitate mai clară",
      "flux mai simplu pentru echipă",
      "organizare centralizată a solicitărilor",
    ],
    cta: "Solicită varianta Pro",
  },
  {
    icon: CreditCard,
    title: "Pentru horeca & cazări",
    badge: "Varianta Pro + Plată online",
    text: "Pentru locațiile care vor rezervări mai bine confirmate și un flux complet, cu plată online integrată și opțiuni promoționale.",
    features: [
      "tot ce include varianta Pro",
      "plată online integrată",
      "confirmări mai clare pentru rezervări",
      "sistem de fidelizare cu vouchere promoționale",
      "experiență mai fluidă pentru oaspeți",
    ],
    cta: "Solicită varianta cu plată online",
  },
];

export const services = [
  {
    icon: MonitorSmartphone,
    title: "Prezentare profesională pentru businessul tău",
    text: "O pagină modernă, optimizată pentru mobil, care pune în valoare serviciile tale și inspiră încredere din primul moment.",
  },
  {
    icon: Mail,
    title: "Primești cereri direct de la clienți",
    text: "Solicitările vin direct către tine, într-un flux clar, rapid și ușor de gestionat, fără pași inutili.",
  },
  {
    icon: Search,
    title: "Businessul tău poate fi găsit mai ușor online",
    text: "Structura paginii este pregătită pentru o prezență digitală mai clară, cu bază bună pentru SEO și promovare.",
  },
  {
    icon: Sparkles,
    title: "Tu ne trimiți informațiile, noi ne ocupăm de restul",
    text: "Ne ocupăm de configurare, structură, direcție vizuală și implementare, astfel încât lansarea să fie simplă pentru tine.",
  },
];

export const processSteps = [
  {
    title: "Ne spui cum funcționează acum businessul tău",
    text: "Discutăm despre tipul de rezervări sau programări, ce informații vrei să prezinți și ce flux ți se potrivește.",
  },
  {
    title: "Configurăm structura și varianta potrivită",
    text: "Pregătim pagina, formularele, textele și, dacă este nevoie, panoul de administrare sau plata online.",
  },
  {
    title: "Lansezi și începi să primești solicitări mai clar",
    text: "Ai o prezentare online profesionistă și un sistem simplu prin care cererile ajung organizat către tine sau echipa ta.",
  },
];

export const benefits = [
  {
    title: "Mai puține cereri pierdute.",
    text: "Când clientul găsește rapid informațiile importante și are un mod clar de a trimite o solicitare, scade riscul să pierzi interesul deja existent.",
  },
  {
    title: "Mai mult control asupra modului în care ajung cererile.",
    text: "În funcție de varianta aleasă, primești solicitările direct pe email sau le gestionezi dintr-un panou dedicat, într-un mod mai organizat.",
  },
  {
    title: "Prezență online mai profesionistă.",
    text: "Rezervix îți oferă o pagină clară, bine structurată și optimizată pentru mobil, care inspiră mai multă încredere din primul contact.",
  },
  {
    title: "Bază bună pentru SEO și promovare.",
    text: "Structura platformei este gândită să susțină o vizibilitate mai bună în online și să funcționeze bine împreună cu promovarea ta existentă.",
  },
  {
    title: "Experiență mai simplă pentru client și echipă.",
    text: "Clientul înțelege mai repede ce oferi, iar tu primești cererea într-un mod mai ușor de urmărit și gestionat.",
  },
];

export const showcasesBasic = [
  {
    kicker: "PRIMA IMPRESIE",
    title: "Un început clar, care prezintă rapid businessul și direcționează vizitatorul către solicitare.",
    text: "Pagina de start oferă informațiile esențiale din primul ecran, astfel încât clientul să înțeleagă rapid ce oferi.",
    image: "/images/heroBasic.webp",
  },
  {
    kicker: "PREZENTARE SERVICII",
    title: "Pui în evidență pe scurt ce oferi.",
    text: "Vizitatorii descoperă ușor principalele servicii sau avantaje, într-o structură simplă și ușor de parcurs.",
    image: "/images/roomsBasic.webp",
    reverse: true,
  },
  {
    kicker: "DETALII UTILE",
    title: "Prezinți informațiile importante într-un mod clar.",
    text: "Clienții găsesc rapid program, servicii, facilități sau informațiile care îi ajută să ia decizia.",
    image: "/images/featuresBasic.webp",
  },
  {
    kicker: "GALERIE FOTO",
    title: "Imaginile completează prezentarea și susțin încrederea.",
    text: "Galeria te ajută să prezinți spațiul, atmosfera sau serviciile într-un mod mai convingător.",
    image: "/images/galleryBasic.webp",
    reverse: true,
  },
  {
    kicker: "LOCALIZARE",
    title: "Vizitatorii văd ușor unde te găsesc.",
    text: "Secțiunea de localizare îi ajută să înțeleagă rapid zona și cum pot ajunge la tine.",
    image: "/images/locationBasic.webp",
  },
  {
    kicker: "ÎNTREBĂRI FRECVENTE",
    title: "Oferi răspunsuri utile la cele mai comune întrebări.",
    text: "Clarifici informațiile de bază înainte ca utilizatorul să trimită o cerere.",
    image: "/images/faqBasic.webp",
    reverse: true,
  },
];

export const showcases = [
  {
    kicker: "PRIMA IMPRESIE",
    title: "Primul ecran prezintă businessul și invită vizitatorul să trimită o cerere.",
    text: "Este gândit pentru conversie: imagine puternică, mesaj clar și acces rapid către formularul de rezervare sau programare.",
    image: "/images/hero.webp",
  },
  {
    kicker: "DE CE SĂ TE ALEAGĂ",
    title: "Prezinți clar ce oferi și de ce merită ales businessul tău.",
    text: "Structura paginii transmite încredere și îi ghidează pe vizitatori către următorul pas.",
    image: "/images/rooms.webp",
    reverse: true,
  },
  {
    kicker: "SERVICII & INFORMAȚII",
    title: "Prezinți clar serviciile și detaliile importante.",
    text: "Utilizatorii înțeleg rapid ce oferi și pot lua mai ușor decizia de a trimite o solicitare.",
    image: "/images/features.webp",
  },
  {
    kicker: "GALERIE FOTO",
    title: "Imaginile pun în valoare businessul tău.",
    text: "O galerie bine organizată susține percepția premium și ajută utilizatorul să își facă rapid o idee clară.",
    image: "/images/gallery.webp",
    reverse: true,
  },
  {
    kicker: "LOCALIZARE",
    title: "Arăți clar unde te afli",
    text: "Harta și informațiile despre locație cresc încrederea și fac contactul mai simplu.",
    image: "/images/location.webp",
  },
  {
    kicker: "ÎNTREBĂRI FRECVENTE",
    title: "Răspunsuri clare pentru o decizie mai rapidă.",
    text: "Clarifici cele mai frecvente întrebări și elimini blocajele care pot împiedica o solicitare.",
    image: "/images/faq.webp",
    reverse: true,
  },
];

export const showAdmin = [
 {
    kicker: "Bookings",
    title: "Controlezi rezervările și programările dintr-un singur loc.",
    text: "Vezi solicitări, disponibilitate și informațiile importante într-un flux simplu și ușor de urmărit.",
    image: "/images/admin.webp",
    reverse: true,
  },
];

export const clientSites = [
  {
    category: "catdaulanunta.ro",
    title: "Platformă de conținut și instrument util pentru utilizator",
    text: "Exemplu de structură clară și experiență gândită astfel încât utilizatorul să parcurgă ușor informația și să interacționeze cu platforma.",
    image: "/images/catdaulanunta.webp",
    demoUrl: "http://catdaulanunta.ro/",
  },
  {
    category: "consultantmarketing.ro",
    title: "Site de prezentare cu structură aerisită și direcție premium",
    text: "Un exemplu de prezentare modernă, construită pentru claritate, credibilitate și o experiență vizuală mai atentă.",
    image: "/images/consultant.webp",
    demoUrl: "http://consultantmarketing.ro/",
  },
  {
    category: "BellaCasa Cluj",
    title: "Demo pentru cazare cu focus pe rezervări directe",
    text: "Direcție vizuală și structură orientate spre informații clare, imagini bune și un flux simplu pentru cereri directe.",
    image: "/images/bellacasacluj.webp",
    demoUrl: "http://rezervix.ro/",
  },
];

export const designDemos = [
  {
    tag: "Elegant & premium",
    title: "",
    text: "",
    image: "/images/hero.webp",
    demoUrl: "http://demo-premium.rezervix.ro/",
  },
  {
    tag: "Modern & clean",
    title: "",
    text: "",
    image: "/images/heroBasic.webp",
    demoUrl: "http://demo.rezervix.ro/",
  },
];
